import React from 'react'
import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { MainListItems } from './listItems';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
const DrawerCompnent = ({toggleDrawer, open}) => {
  const routeName = window.location.pathname
  const token = useSelector((state) => state.auth.token);
  
    const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
        ({ theme, open }) => ({
            backgroundColor:"black",
            height:"100vh",
            '& .MuiDrawer-paper': {
            position: 'relative',
            whiteSpace: 'nowrap',
            width: 240,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(7),
                [theme.breakpoints.up('sm')]: {
                width: theme.spacing(9),
                },
            }),
            },
        }),
    );

  if (routeName == "/pp") return null
  return (
     <Drawer sx={{
        display:!token&&"none",
        maxWidth:300,
        height:"100%",
        backgroundColor:"black",
     }} variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
               backgroundColor:"#222E41",
              color:"white",
              px: [1],
            }}
          >
            <Typography variant="h6">Expert Minute</Typography>
            <IconButton sx={{color:"white"}} onClick={toggleDrawer}>
              <ChevronLeftIcon color='white' />
            </IconButton>
          </Toolbar>
          <Divider />
          <List sx={{
            backgroundColor:"#222E41",
              color:"white",
              height:"90vh",
              overflow:"hidden",
              overflowX:"hidden",
              overflowY:"hidden",
          }} component="nav">
            <MainListItems/>
            {/* <Divider sx={{ my: 1 }} />
            {secondaryListItems} */}
          </List>
        </Drawer>
  )
}

export default DrawerCompnent